import Vue from 'vue';
import LazyLoadDirective from '@/directives/LazyLoadDirective';
import Cart from '@components/Cart/Cart';
import CartItem from '@components/Cart/CartItem';
import SvgLoader from '@components/Common/SvgLoader';

Vue.config.productionTip = false;
Vue.prototype.$http = window.axios;

Vue.directive('lazyload', LazyLoadDirective);

const cartApp = new Vue({
  el: '#cart-mount',

  components: {
    Cart,
    CartItem,
    SvgLoader,
  },
});
